<script lang="ts">import { t } from "@infinitro/content";
import { Text } from "@infinitro/text";
export let icon;
export let label;
</script>

<div class="feature-badge">
	<span class="feature-badge-icon">
		<img src={icon} alt="" />
	</span>
	<Text bodyWeight="regular" bodySize="small">
		{$t(label)}
	</Text>
</div>

<style>
	.feature-badge {

    display: flex;

    align-items: center;

    gap: 0.5rem
}

	.feature-badge-icon {

    display: flex;

    flex-shrink: 0;

    align-items: center;

    justify-content: center
}
</style>
